export class CaseTypeDtColumnName {
    public static readonly Name = 'name';
    public static readonly Tag = 'tag';
    public static readonly IsPublicCaseRequest = 'isPublicCaseRequest';
    public static readonly description = 'description';
}
